import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Layout from './pages/Layout';
import { Contact } from './pages/Contact';
import { About } from './pages/About';
import Content from './components/Content';

const App = () => {
  return (
    <Routes>
      <Route path="/*" element={
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/page/:id" element={<Content />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>} />
    </Routes>
  );
};

export default App;
